import Vue from 'vue'
import EventBus from '../_event-bus'

Vue.component('vue-mini-cart', {
  template: '#vue-mini-cart-template',
  props: ['initialItems'],
  data() {
    return {
      cartLink: `${process.env.BASE_URL}${process.env.CART_URL}`,
      items: this.initialItems,
    }
  },
  methods: {
    addItemUpdateListener,
    removeItem,
    updateItems,
  },
  mounted() {
    this.addItemUpdateListener()
  },
})

function addItemUpdateListener() {
  EventBus.$on('update-cart', this.updateItems)
}

function removeItem(id) {
  EventBus.$emit('remove-from-cart', { id })
}

function updateItems(items) {
  this.items = items
}
